import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import NavBar from './components/NavBar.js'
import Home from './components/Home.js'
import DataRows from './components/DataRows.js'
import Data from './data/Data.js'
import AssociatedPapers from './components/AssociatedPapers.js'

const  App = () => {
  // App has two parts, get and parse data, which is local in a file and NOT in the web, so easier to deal with. 
  // Also not seeded into a database, so no worries there.
  // can start with a small manually created data file, and then figure out how to load the data into it.
  // could even process the data separately and then copy and paste it in if I can't get it to just process and go. That way at least it's hosted
  // in a format here, that is accessible and not processing from an excel file every time. But then if she updates the excel file, it won't update.
  // so long term goal shoul dbe to just have a folder we can drag and drop a similarly formatted excel file and have it still work.
  
  // *** MY TOP TWENTY IS EMPTY
  // *** MY DATA IS NOT PROCESSED
  // *** THE CSS DOES NOT EXIST
  
  return (
    <BrowserRouter>
      <NavBar />
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route exact path="/search-data">
          <DataRows dataArray={Data}/>
        </Route>
        <Route exact path="/associated-papers">
          <AssociatedPapers />
        </Route>
      </Switch>
    </BrowserRouter>
  )
}

export default App